// Contacto.js
import React from 'react';

const Contacto = () => {
  return (
    <section className="py-20 px-4 bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-10">Contáctanos</h2>
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 text-left">
        <div>
          <form className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-1">Nombre</label>
              <input type="text" className="w-full border border-gray-300 p-3 rounded-md" placeholder="Tu nombre" />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Correo electrónico</label>
              <input type="email" className="w-full border border-gray-300 p-3 rounded-md" placeholder="tu@email.com" />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Mensaje</label>
              <textarea className="w-full border border-gray-300 p-3 rounded-md h-32" placeholder="¿En qué podemos ayudarte?"></textarea>
            </div>
            <button type="submit" className="bg-[#003366] text-white px-6 py-3 rounded-full hover:bg-blue-800 transition">
              Enviar mensaje
            </button>
          </form>
        </div>
        <div className="text-gray-700 space-y-4">
          <p><strong>Razón Social:</strong> INVERSIONES BVT, C.A.</p>
          <p><strong>RIF:</strong> J-29987858-8</p>
          <p><strong>Correo Electrónico:</strong> info@inversionesbvt.com</p>
          <p><strong>Persona Contacto:</strong> Lic. Fernando Torrealba</p>
          <p><strong>Teléfonos:</strong></p>
          <ul className="ml-4 list-disc">
            <li>Fijo: +58 261-7981181</li>
            <li>Móvil: +58 414-6358199</li>
            <li>Móvil: +58 412-0628220</li>
            <li>Móvil: +1 754-2991058</li>
          </ul>
          <p><strong>Direcciones:</strong></p>
          <ul className="ml-4 list-disc">
            <li>Sede Administrativa: Calle 67 con av. 8B Local 9 PB, Maracaibo Estado Zulia</li>
            <li>Patio: Depósito calle 42 entre avenidas N y Vargas, Ciudad Ojeda</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Contacto;